import React from 'react';
import BBIconCheck from "../../assets/bbCustomIcons/BBIconCheck";
import {HashLink as Link} from "react-router-hash-link";

//TODO: Knowledge Base or Interactive User guide link to WHY to add??

const BRBizInitialTourVerification = {
    url: `/board/BreachRisk/Business/Verifications`,
    type: `tutorial`,
    user: {
        first_login: true,
    },
    entity: {
        verified_ownership: true,
        hasScores: null,
    },
    openingModal: {
        icon: null,
        heading: "Verifying Your IT Infrastructure Improves Fidelity",
        description: <div className={"text-center"}>
            <p>
                Use the graphs and forms on this page to add elements of your IT infrastructure into the BreachRisk&trade; Engine.
                Each of the tables are divided into IPs, Domains, and Subdomains and will list those elements which you have already added.
            </p>
            <p>
                To find the exhaustive list of elements discovered by us and added by your company, visit the <Link to={`/board/BreachRisk/Business/Report/TechData`}className={"text-white"}><u>Technical Details Page.</u></Link>
            </p>

        </div>
    },
    tourSteps:{
        1:{
            step: 1,
            title: "Added By You",
            content: "Each table includes the elements that have been added by you or your team and the date they were added.",
            scrollToElement: false,
            anchorEl: "#tourIPsAddedTable",
            element: document.getElementsByClassName('tourAddITElements'),
            last: false,
        },
        2:{
            step: 2,
            title: "New Elements",
            content: "Each table has a corresponding form to add elements from your infrastructure.",
            scrollToElement: false,
            anchorEl: "#tourAddElementButton_IP Address",
            element: document.getElementsByClassName('highlightAddITElementButton'),
            last: true,
        },
        // 3:{
        //     step: 3,
        //     title: "",
        //     content: "",
        //     scrollToElement: null,
        //     anchorEl: "",
        //     element: null,
        //     last: false,
        // },
        // 4:{
        //     step: 4,
        //     title: "",
        //     content: "",
        //     scrollToElement: null,
        //     anchorEl: "",
        //     element: null,
        //     last: false,
        // },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}

export default BRBizInitialTourVerification;